import React from "react";
import { motion } from "framer-motion";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "./ui/accordion";
import { useLang } from "../i18n/LanguageContext";

const items = ["faq_q1", "faq_q2", "faq_q3", "faq_q4"];

export const FAQ = () => {
  const { t } = useLang();
  return (
    <section id="faq" className="relative py-24 lg:py-32" data-testid="faq-section">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <div className="max-w-3xl mb-14">
          <div className="text-xs tracking-[0.2em] uppercase font-mono text-cyan mb-4">{t("faq_eyebrow")}</div>
          <h2 className="font-head font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-white">{t("faq_title")}</h2>
          <p className="mt-5 text-base text-zinc-400 leading-relaxed">{t("faq_subtitle")}</p>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <Accordion type="single" collapsible className="w-full">
            {items.map((q, i) => (
              <AccordionItem
                key={q}
                value={q}
                className="border-white/10"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="font-head text-lg sm:text-xl text-white hover:no-underline hover:text-cyan py-6 [&>svg]:text-cyan [&>svg]:h-5 [&>svg]:w-5">
                  {t(q)}
                </AccordionTrigger>
                <AccordionContent className="text-zinc-400 text-base leading-relaxed pr-6">
                  {t(`faq_a${i + 1}`)}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
};
